import { ApiPropertyOptional, PartialType } from '@nestjs/swagger';
import { IsBoolean, IsOptional } from 'class-validator';
import { CreateEtapaDto } from './create-etapa.dto';

export class UpdateEtapaDto extends PartialType(CreateEtapaDto) {
  @ApiPropertyOptional({ example: true, description: 'Baja lógica: la etapa nunca se borra.' })
  @IsOptional()
  @IsBoolean()
  activo?: boolean;
}
